import React from 'react';
import {useDropzone} from 'react-dropzone';
import { useState, useCallback } from "react";
import { BsCardImage } from "react-icons/bs";

function ChatUserFileUpload(props) {
  const [files, setFiles] = useState([]);

  const onDrop = useCallback((acceptedFiles) => {
    let fileArray = [];
    const files = acceptedFiles.map(function(file) {
      if((file.type === "image/png" || file.type === "image/jpeg" || file.type === "image/jpg") && fileArray.length === 0) {
        fileArray.push(file);
      }
      return(
        file.type === "image/png" || file.type === "image/jpeg" || file.type === "image/jpg"
          ?
        <img key={file.path} src={URL.createObjectURL(file)} className="w-10 h-10" />
          :
        null
      );
    }).filter(x => x).slice(0, 1);

    setFiles(files);
    if(fileArray.length > 0) {
      props.setUploadedFile(fileArray[0]);
    }
  }, []);
  const {getRootProps, getInputProps} = useDropzone({
    onDrop
  });

  return (
    <div>
      {
        files.length === 0
          ?
        <div>
          <div {...getRootProps({className: 'dropzone'})}>
            <input {...getInputProps()} />
            <div className="flex flex-col justify-center items-center w-[76px]">
              <div className="w-10 h-10 rounded-full bg-zinc-700 justify-center items-center flex text-zinc-400 cursor-pointer">
                <BsCardImage />
              </div>
              <div
                className={
                  props.chosenType === 'upload'
                    ?
                  "text-[10px] text-white mt-2"
                    :
                  "text-[10px] text-zinc-400 mt-2"
                }
              >
                UPLOAD
              </div>
            </div>
          </div>
        </div>
          :
        <div>
          <div {...getRootProps({className: 'dropzone'})}>
            <input {...getInputProps()} />
            <div className="flex flex-col justify-center items-center w-[76px]">
              {files}
              <div
                className={
                  props.chosenType === 'upload'
                    ?
                  "text-[10px] text-white mt-2"
                    :
                  "text-[10px] text-zinc-400 mt-2"
                }
              >
                UPLOAD
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default ChatUserFileUpload;